<template>
    <div class="roulette-gift-button" v-if="!popupRouletteShow && !checkReceivDiscount()">
        <img src="../assets/icons/gift.svg" @click="open" alt="" />
        <div class="roulette-gift-button__label" v-if="showGiftMessage">
            <svg @click="hiddenMessage" viewBox="0 0 30 30" width="20" height="20">
                <rect width="30" height="30" rx="15" transform="matrix(1 0 0 -1 0 30)" fill="primary" fill-opacity="1"></rect>
                <path d="M19.1668 10.8334L10.8335 19.1667M10.8335 10.8334L19.1668 19.1667" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <div @click="open">Отримай бонус!</div>
        </div>
    </div>
    <div class="popup" :class="{ 'popup-show': popupRouletteShow }">
        <div class="popup__wrapper">
            <confetti-explosion v-if="visibleConfetti"></confetti-explosion>
            <div class="popup__content">
                <div class="cart__top top-cart">
                    <div></div>
                    <button type="button" class="popup__close _icon-close" @click="popupRouletteShow = false"></button>
                </div>
                <div class="popup__roulette-content">
                    <div class="popup__roulette-col">
                        <div class="popup__roulette-roulette">
                            <roulette-component ref="rouletteComponent" @wheel-stopped="handleWheelStopped"></roulette-component>
                        </div>
                    </div>
                    <div class="popup__roulette-col" v-if="!discountReceived">
                        <div class="popup__roulette-header">
                            <h2>Вигравай знижку!</h2>
                            <p>Крути колесо фортуни та отримай призи! Для участі введи свої данні:</p>
                        </div>
                        <div class="popup__roulette-form">
                            <input class="input" name="firstName" type="text" v-model="fieldFirstName" placeholder="Ваше ім’я *" required />
                            <input class="input" name="phone" type="text" v-model="fieldPhone" placeholder="Телефон *" required @input="formatPhone" />
                            <input class="input" :class="{ 'input-error': !emailValid }" name="email" type="email" v-model="fieldEmail" placeholder="E-mail *" required @input="validateEmail" />
                            <button class="button" @click="launchWheel">Крутити</button>
                            <Chekbox is-cheked-default="true">
                                <span> Я погоджуюся з <NuxtLink to="offerta" target="_blank">договором оферти і політикою конфіденційності</NuxtLink> </span>
                            </Chekbox>
                        </div>
                    </div>
                    <div class="popup__roulette-col" v-if="discountReceived">
                        <div class="popup__roulette-header">
                            <h2>Вітаємо! <br />Ви виграли знижку {{ discount }} <br />Ваш промокод: {{ discountPromocode }}</h2>
                            <button class="button" @click="popupRouletteShow = false">
                                <span>Обрати прикрасу</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useToast } from "vue-toast-notification";
import ConfettiExplosion from "vue-confetti-explosion";
import RouletteComponent from "./RouletteComponent.vue";
import Chekbox from "./Chekbox.vue";
import { useRuntimeConfig, useCookie } from "#app"; // Используем useCookie для работы с куками

// Инициализация toast
const toast = useToast();

// Реактивные данные
const config = useRuntimeConfig();
const apiUrl = config.public.apiUrl; // Access the apiUrl
const popupRouletteShow = ref(false);
const rouletteComponent = ref(null);
const fieldFirstName = ref("");
const fieldPhone = ref("");
const fieldEmail = ref("");
const submitForm = ref(false);
const discountReceived = ref(false);
const discount = ref("");
const discountPromocode = ref("");
const visibleConfetti = ref(false);
const emailValid = ref(true);
const showGiftMessage = ref(false);
const giftMessageShown = ref(false);

// Работа с куками через useCookie
const popupShownCookie = useCookie("popupShown");
const discountReceivedCookie = useCookie("discountReceived");
const utmCookie = useCookie("utm");

// Методы
const validateEmail = () => {
    const re = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    emailValid.value = re.test(fieldEmail.value);
};

const formatPhone = () => {
    let value = fieldPhone.value.replace(/\D/g, "");
    if (value.length > 12) value = value.slice(0, 12);
    if (value.length > 2) value = `+${value.slice(0, 2)} (${value.slice(2, 5)})${value.slice(5, 8)}-${value.slice(8, 10)}-${value.slice(10, 12)}`;
    else if (value.length > 0) value = `+${value}`;
    fieldPhone.value = value;
};

const launchWheel = () => {
    validateEmail();

    if (submitForm.value) return;

    if (fieldFirstName.value.length > 0 && fieldPhone.value.length > 0 && fieldEmail.value.length > 0 && !submitForm.value) {
        if (!emailValid.value) {
            toast.error("Введіть коректну електронну адресу.");
            return;
        }

        rouletteComponent.value.spin();
        submitForm.value = true;
    } else {
        toast.error("Будь ласка, заповніть всі обов'язкові поля.");
    }
};

const getUTMData = () => {
    try {
        return JSON.parse(utmCookie.value || "{}");
    } catch {
        return {};
    }
};

const handleWheelStopped = async (text) => {
    const utmData = getUTMData();
    let formData = {
        precent: text,
        email: fieldEmail.value,
        phone: fieldPhone.value,
        name: fieldFirstName.value,
        withCredentials: true,
    };

    Object.keys(utmData).forEach((key) => {
        formData[key] = utmData[key];
    });

    try {
        const data = await $fetch(`${apiUrl}promocode/generate`, {
            method: "POST",
            body: formData,
        });

        visibleConfetti.value = true;
        discountPromocode.value = data.code;
        discount.value = text;
        discountReceived.value = true;
        discountReceivedCookie.value = true;
    } catch (error) {
        console.error("Ошибка при запросе:", error);
    }
};

const openPopup = () => {
    if (popupShownCookie.value || discountReceivedCookie.value) return;

    setTimeout(() => {
        popupRouletteShow.value = true;
        popupShownCookie.value = true;
    }, 30000);
};

const open = () => {
    popupRouletteShow.value = true;
};

const handleScroll = () => {
    if (!giftMessageShown.value && typeof window !== "undefined" && window.scrollY > 500) {
        showGiftMessage.value = true;
        giftMessageShown.value = true;
    }
};

const hiddenMessage = () => {
    showGiftMessage.value = false;
};

const checkReceivDiscount = () => {
    return discountReceivedCookie.value === "true";
};

// Жизненный цикл
onMounted(() => {
    openPopup();
    if (typeof window !== "undefined") {
        window.addEventListener("scroll", handleScroll);
    }
});

onUnmounted(() => {
    if (typeof window !== "undefined") {
        window.removeEventListener("scroll", handleScroll);
    }
});
</script>

<style lang="scss" scoped>
.popup__roulette-content {
    display: flex;
    align-items: center;
    padding: 0 10px;
    padding-top: 40px;
    padding-bottom: 40px;
}

@media (max-width: 768px) {
    .popup__roulette-content {
        flex-direction: column;
        row-gap: 20px;
    }
    .popup__roulette-roulette {
        display: flex;
        justify-content: center;
    }
}

.popup__roulette-header {
    text-align: center;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    margin-bottom: 25px;
}

.popup__roulette-header h2 {
    font-size: 30px;
    font-weight: bold;
}

.popup__roulette-header p {
    font-size: 16px;
}

.popup__roulette-form {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
}

.popup__roulette-form .input {
    border-radius: 6px !important;
    border: 1px solid #000000bd;
}
.popup__roulette-form .button {
    width: 100%;
}
.popup__roulette-col {
    width: 100%;
}
.input-error {
    border-color: red !important;
}

/* roulette-gift-button */

.roulette-gift-button {
    position: fixed;
    z-index: 2;
    right: 65px;
    left: auto;
    bottom: 85px;
    background: #ff9fde;
    width: 60px;
    height: 60px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    transition: background 0.3s;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 8px;

    &:hover {
        background: #ffd2f0;
        box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    }

    img {
        width: 30px;
        height: 30px;
    }

    &__label {
        position: absolute;
        top: -50px;
        left: -20%; /* Центрируем */
        transform: translateX(-50%);
        background-color: #ff9fde;
        color: #333; /* Цвет текста для читабельности */
        padding: 10px 20px;
        border-radius: 20px;
        text-align: center;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        white-space: nowrap; /* Для предотвращения переноса текста */
        font-size: 12px;
        &:after {
            content: "";
            position: absolute;
            bottom: -19px; /* Расположить стрелку под текстом */
            right: 20px; /* Расположить справа */
            width: 0;
            height: 0;
            border-width: 10px;
            border-style: solid;
            border-color: #ff9fde transparent transparent transparent; /* Верхний треугольник */

            @media (max-width: $mobile) {
                right: 24px;
            }
        }

        svg {
            position: absolute;
            top: -13px;
            right: -13px;

            @media (max-width: $mobile) {
                right: 0;
                top: -24px;
            }
        }
    }

    @media (max-width: $mobile) {
        right: 20px;
        bottom: 75px;

        width: 50px;
        height: 50px;

        img {
            width: 25px;
            height: 25px;
        }
    }

    .roulette-gift-button-message {
        position: absolute;
        top: -50px;
        left: -20%; /* Центрируем */
        transform: translateX(-50%);
        background-color: #ff9fde;
        color: #333; /* Цвет текста для читабельности */
        padding: 10px 20px;
        border-radius: 20px;
        text-align: center;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        white-space: nowrap; /* Для предотвращения переноса текста */
        font-size: 12px;
        &:after {
            content: "";
            position: absolute;
            bottom: -19px; /* Расположить стрелку под текстом */
            right: 20px; /* Расположить справа */
            width: 0;
            height: 0;
            border-width: 10px;
            border-style: solid;
            border-color: #ff9fde transparent transparent transparent; /* Верхний треугольник */
        }

        // &:before {
        //     content: "";
        //     background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23ff9fde' viewBox='0 0 30 30' width='20' height='20'%3E%3Crect width='30' height='30' rx='15' transform='matrix(1 0 0 -1 0 30)' fill='primary' fill-opacity='1'%3E%3C/rect%3E%3Cpath d='M19.1668 10.8334L10.8335 19.1667M10.8335 10.8334L19.1668 19.1667' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/svg%3E");
        //     position: absolute;
        //     top: -13px;
        //     right: -13px;
        //     width: 20px;
        //     height: 20px;
        // }

        @media (max-width: $mobile) {
            &:after {
                right: 25px;
            }
        }
    }
}
</style>
